// ============================================================
// แก้ไข/ลงประกาศทรัพย์ (/project-room-edit?customer_id=...)
// ------------------------------------------------------------
// การ์ด: ขอปรับหน้าจอฝั่ง Admin ตามรูป (trello JL2fsdKP)
//
// ★ เลิกใช้ "ขั้นตอน (wizard)" แล้ว — ทั้งหน้าเป็นแถวยาวหน้าเดียว จัดกลุ่มด้วยการ์ด
//   เหตุผล: แอดมินที่มาตรวจประกาศก่อนกดอนุมัติ ต้องเห็นข้อมูลทั้งใบพร้อมกัน
//   ไม่ใช่เดินทีละขั้นแล้วจำว่าขั้นก่อนหน้ากรอกอะไรไว้
//
// โครงหน้า (2 คอลัมน์ เลื่อนลงยาว)
//   ซ้าย  : ประเภทประกาศ › ข้อมูลการขาย › ข้อมูลการเช่า › ผู้เช่าเดิม ›
//           ช่วงเวลาประกาศ › การจอง › ผู้ติดต่อ Admin › หมายเหตุ+การเผยแพร่
//   ขวา   : รูปภาพทรัพย์ + ชุดสรุปแบบที่ผู้ซื้อจะเห็น › ข้อมูลทรัพย์ (สเปก+ที่อยู่+สิ่งอำนวยความสะดวก)
//           › ข้อมูลบนหน้าเว็บ (จุดเด่น/รายละเอียด)
//
// ★ ชุดสรุปใต้รูปเป็น "ตัวแสดงผล" ไม่ใช่ช่องกรอก — ทุกค่าผูกกับ state ของฟอร์มโดยตรง
//   แก้ราคา/สถานะ/ที่อยู่ ตรงไหน ชุดสรุปเปลี่ยนทันที (ข้อมูลหลอกตาอันตรายกว่าไม่มี)
//   ค่าที่ยังไม่กรอกแสดงเป็น "ยังไม่ระบุ" สีจาง ไม่ปล่อยว่าง
//
// ★ ผู้ใช้ที่ไม่มีสิทธิ์เขียน (sale-listing.create ตอนลงประกาศใหม่ / sale-listing.update ตอนแก้ไข)
//   เปิดดูได้ แต่ช่องกรอกถูก disable และไม่มีปุ่มบันทึก/อนุมัติ (ดู canWrite / isLocked)
//   (โหมด &view=1 เดิมถูกลบไปพร้อมหน้า /project-room-sales)
//
// ★ ห้องจะขึ้นหน้าเว็บสาธารณะก็ต่อเมื่อ is_published = true เท่านั้น
//   ประกาศที่ลูกค้าส่งมาจะเป็น publish_status = "รอเผยแพร่" ต้องให้แอดมินกด "อนุมัติ" ที่หัวหน้านี้
// ★ ชื่อ/เบอร์ผู้เช่า ผู้จอง และผู้ติดต่อ เป็นข้อมูลภายใน API สาธารณะไม่ส่งออก
// ============================================================

import React, { Component } from "react";
import { NumericFormat } from "react-number-format";
import PropertyNavbar from "../../components/PropertyNavbar.js";
import { stripJuristic } from "../../components/text-sanitize.js";
import {
  GET,
  POST,
  PUT,
  alert,
  loading,
  Resizer,
  getCurrentProject,
  isCustomerProfile,
  hasPermission,
  onlyPhoneDigits,
  formatSaleDate,
  Select,
  DateTimePicker,
} from "../../components/CustomComponent.js";

import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/property.css";
import "../../assets/css/property_form.css";
// ★ ต้องมาหลังสุด — ไฟล์นี้เขียนทับตัวแปรสีให้เป็นธีม CDS P2
import "../../assets/css/property-theme-cds.css";
import {
  SELLING_STATUS,
  RENT_STATUS,
  PUBLISH_STATUS,
  PUBLISH_BADGE,
  hasSale,
  hasRent,
  money,
  toApiDateTime,
} from "../../constants/sale.js";

const RENT_COMMISSION_METHODS = ["ค่าตอบแทนค่าดำเนินการ 1 เดือน", "กำหนดรูปแบบค่าดำเนินการ"];
// ★ ไม่มีช่องเลือกประเภททรัพย์บนหน้าจอแล้ว — ทุกห้องในระบบนี้เป็นห้องชุด
//   ยังส่งค่าไป backend ตามเดิม (คอลัมน์ property_type ยังอยู่ และ validate ฝั่ง server ยังตรวจ)
const DEFAULT_PROPERTY_TYPE = "ห้องชุด";

// ---- ข้อจำกัดของรูปห้อง ----
// ★ 10 รูป/ห้อง — มากกว่านี้คนดูก็ไม่เลื่อนดู แต่ payload ตอนบันทึกโตขึ้นเรื่อย ๆ
// ★ 5MB ต่อไฟล์ (ขนาดไฟล์จริงก่อนย่อ) — กันรูปจากกล้องความละเอียดสูงทำให้อัปโหลดค้าง
// ★ ย่อด้านยาวสุดเหลือ 1200px ก่อนส่ง (ไฟล์เล็กกว่านี้ Resizer จะไม่ขยายให้)
const MAX_IMAGES = 10;
const MAX_IMAGE_MB = 5;
const IMAGE_RESIZE_PX = 1200;

// ★ ฝั่งลูกบ้านกรอกเป็นขั้นตอน (ทีละเรื่อง ไม่ต้องเจอฟอร์มยาวทั้งหน้า)
//   ฝั่งผู้ดูแลใช้หน้าเดียวเลื่อนยาวเหมือนเดิม เพราะต้องตรวจทั้งใบพร้อมกันก่อนกดอนุมัติ
//   เนื้อในของแต่ละขั้นใช้การ์ดชุดเดียวกับฝั่งผู้ดูแลทุกใบ (renderXxxCard) ไม่ได้ทำฟอร์มแยก
const STEPS = [
  { no: 1, label: "ข้อมูลประกาศ" },
  { no: 2, label: "รูปภาพ" },
  { no: 3, label: "ข้อมูลทรัพย์" },
  // ขั้นสุดท้ายรวม "ข้อมูลบนหน้าเว็บ" + หมายเหตุถึงผู้ดูแล ไว้กับชุดสรุปก่อนกดส่ง
  { no: 4, label: "ตรวจสอบ" },
];

// ประเภทประกาศบนหน้าจอ
// ★ "ขายพร้อมผู้เช่า" ไม่ใช่ listing_type ใหม่ใน DB — เป็น listing_type = "ขาย" + sell_with_tenant = true
//   (เก็บโครงข้อมูลเดิมไว้ ไม่ต้องแก้ backend/หน้าเว็บสาธารณะเพราะปุ่มบนหน้าจอ)
const LISTING_CHOICES = [
  { key: "ขาย", label: "ขาย", listing_type: "ขาย", sell_with_tenant: false },
  { key: "เช่า", label: "เช่า", listing_type: "เช่า", sell_with_tenant: false },
  { key: "ขายพร้อมผู้เช่า", label: "ขายพร้อมผู้เช่า", listing_type: "ขาย", sell_with_tenant: true },
  // ★ "ขายและเช่า" เลิกใช้แล้ว — ไม่ให้เลือกใหม่ แต่ยังต้องโชว์ปุ่มให้ประกาศเก่าที่เป็นชนิดนี้อยู่
  //   ไม่งั้นเปิดประกาศเก่ามาแล้วไม่มีปุ่มไหน active และมองไม่ออกว่าตอนนี้เป็นประเภทอะไร
  { key: "ขายและเช่า", label: "ขายและเช่า", listing_type: "ขายและเช่า", sell_with_tenant: false, legacy: true },
];

// เก็บใน DB เป็นข้อความคั่นด้วย ,
const FACILITY_OPTIONS = [
  { label: "เฟอร์นิเจอร์ครบ", icon: "" },
  { label: "เครื่องปรับอากาศ", icon: "" },
  { label: "เครื่องทำน้ำอุ่น", icon: "" },
  { label: "เครื่องซักผ้า", icon: "" },
  { label: "ตู้เย็น", icon: "" },
  { label: "ทีวี", icon: "" },
  { label: "อินเทอร์เน็ต", icon: "" },
  { label: "ที่จอดรถ", icon: "" },
  { label: "ระเบียง", icon: "" },
  { label: "สระว่ายน้ำ", icon: "" },
  { label: "ฟิตเนส", icon: "" },
  { label: "ลิฟต์", icon: "" },
  { label: "รปภ. 24 ชม.", icon: "" },
  { label: "กล้องวงจรปิด", icon: "" },
  { label: "เลี้ยงสัตว์ได้", icon: "" },
];

const EMPTY_FORM = {
  listing_uid: "",          // มีค่า = แก้ไขประกาศเดิม, ว่าง = สร้างใหม่
  customer_id: "",

  listing_type: "ขาย",

  // ★ ช่วงเวลาของ "ตัวประกาศ" ชุดเดียว ใช้ร่วมกันทั้ง ขาย / เช่า / ขายและเช่า
  announce_start_at: "",
  announce_end_at: "",

  price: "",
  selling_status: "ว่าง",
  selling_at: "",
  sold_at: "",
  selling_reason: "",

  // ค่าดำเนินการที่เจ้าของห้องกำหนดเอง — ฟิลด์เดียวใช้ร่วมทุกประเภทประกาศ (label ต่างกัน)
  commission: "",
  rent_commission_method: "กำหนดรูปแบบค่าดำเนินการ",

  rent_price: "",
  rent_status: "",
  rent_deposit: "",
  rent_start_at: "",
  rent_end_at: "",
  rent_reason: "",
  sell_with_tenant: false,
  tenant_name: "",
  tenant_phone: "",
  tenant_notified: false,

  reserve_name: "",
  reserve_phone: "",
  reserve_at: "",
  reserve_expire_at: "",
  reserve_note: "",

  contact_name: "",
  contact_phone: "",
  contact_line: "",
  contact_email: "",

  // ---- ข้อมูลตัวทรัพย์ ----
  property_type: "",
  building_no: "",
  floor: "",
  usable_area: "",
  land_area: "",
  bedroom_count: "",
  bathroom_count: "",
  parking_count: "",

  // ---- ที่อยู่ ----
  address_number: "",
  building_name: "",
  address_moo: "",
  address_soi: "",
  address_road: "",
  address_subdistrict: "",
  address_district: "",
  address_province: "",
  address_postcode: "",
  map_url: "",

  highlight: "",
  facilities: [],
  description: "",
  images: [],
  is_published: true,
  publish_status: "",
  remark: "",
};

// รับได้ทั้ง "YYYY-MM-DD HH:mm" (จาก DTO) และ ISO (จาก model ดิบ)
const toDateTimeInput = (value) => {
  if (!value) return "";
  const text = String(value);
  if (text.includes("T")) return text.slice(0, 16);
  return text.replace(" ", "T").slice(0, 16);
};

// ตัวเลขที่ปล่อยว่างได้ — ว่าง = null ไม่ใช่ 0 (0 ตร.ม. กับ "ยังไม่กรอก" คนละความหมาย)
const toApiNumber = (value) => (value === "" || value === null || value === undefined ? null : Number(value));

// ช่องที่ค่ามาจากทะเบียนลูกบ้าน — หน้านี้แก้ไม่ได้ทั้งฝั่งผู้ดูแลและเจ้าของห้อง
const REGISTRY_HINT = "มาจากทะเบียนลูกบ้าน แก้ได้ที่หน้าข้อมูลลูกบ้าน";

const getParam = (key) => new URLSearchParams(window.location.search).get(key) || "";

export default class ProjectRoomEdit extends Component {
  isCustomer = isCustomerProfile();
  // ★ อ่านจาก cds-project ตัวเดียวกับ header project-id ของ API (ไม่ใช่ตัวแปร project ที่อ่านครั้งเดียวตอน import)
  project = getCurrentProject();

  state = {
    provinces: [],           // ชุดข้อมูล จังหวัด > อำเภอ > ตำบล (assets/files/th_province.json)
    room: null,              // ข้อมูลห้อง (customer)
    form: { ...EMPTY_FORM },
    step: 1,                 // ใช้เฉพาะฝั่งลูกบ้าน (ดู STEPS)
    activeImage: 0,          // รูปที่กำลังโชว์ในกรอบใหญ่
    saving: false,
    publishing: false,       // กำลังอนุมัติ/ไม่อนุมัติ — กันกดซ้ำระหว่างรอ API
    loaded: false,
    errorMessage: "",
    contactFromProject: false, // ข้อมูลติดต่อ Admin ที่เห็นเติมมาจากการตั้งค่าโครงการ (ยังไม่ได้บันทึกกับประกาศ)
  };

  async componentDidMount() {
    if (!localStorage.getItem("cds-acc-tk")) {
      localStorage.clear();
      window.location.href = "/";
      return;
    }
    loading(false);
    window.scrollTo(0, 0);
    this.loadProvinces();
    await this.load();
  }

  // ★ ไฟล์จังหวัดใหญ่ ~700KB — โหลดแยกก้อน (dynamic import) ไม่ให้ไปถ่วง bundle หลักของทั้งเว็บ
  loadProvinces = async () => {
    try {
      const data = await import("../../assets/files/th_province.json");
      this.setState({ provinces: data.default || data || [] });
    } catch (err) {
      // โหลดไม่ได้ = ยังกรอกที่อยู่ได้ตามปกติ แค่ไม่มีตัวเลือกให้เลือก
      console.error("load th_province.json error:", err);
    }
  }

  // ---------- โหลดข้อมูล ----------

  load = async () => {
    const customerId = getParam("customer_id");
    if (!customerId) {
      this.setState({ loaded: true, errorMessage: "ลิงก์ไม่สมบูรณ์ (ต้องมี customer_id ของห้อง)" });
      return;
    }

    loading(true);
    const roomRes = await GET("api/admin/customer/list", { customer_id: customerId }, false);
    if (!roomRes?.status) {
      loading(false);
      this.setState({ loaded: true, errorMessage: "ไม่พบห้องนี้ในโครงการที่เลือกอยู่" });
      return;
    }

    const room = roomRes.data;
    const listing = room?.sale_listing || null;
    let detail = listing;

    // ประกาศเดิม : ดึงข้อมูลเต็มจาก DTO (customer/list ให้มาแค่บางส่วน)
    // ★ ดึงไม่สำเร็จ = เปิดหน้าไม่ได้ ห้ามใช้ room.sale_listing แทน
    //   ข้อมูลชุดนั้นไม่ครบ และรูปเป็น object {image_url, sequence} ไม่ใช่ URL
    //   กดบันทึกแล้ว backend ข้ามค่าที่ไม่ใช่ string = รูปเดิมถูกลบทิ้งทั้งหมด (และช่องที่ไม่มีกลายเป็นค่าว่าง)
    if (listing?.uid) {
      const result = await GET("api/admin/sale-listings", { uid: listing.uid }, false);
      detail = result?.status ? (Array.isArray(result.data) ? result.data[0] : result.data) : null;
      if (!detail) {
        loading(false);
        this.setState({
          loaded: true,
          errorMessage:
            result?.httpStatus === 403
              ? "ไม่มีสิทธิ์ดูรายละเอียดประกาศนี้"
              : "โหลดรายละเอียดประกาศไม่สำเร็จ กรุณาลองใหม่อีกครั้ง (ยังไม่มีการบันทึกข้อมูลใด ๆ)",
        });
        return;
      }
    }

    // ★ ข้อมูลติดต่อ Admin ของประกาศ — ยังไม่ได้กรอกสักช่อง = เติมจาก "การตั้งค่าการขาย (โครงการ) > ข้อมูลติดต่อ Admin"
    //   ผู้ใช้บางบทบาทอาจไม่มีสิทธิ์อ่านการตั้งค่า (GET เงียบ ไม่ขึ้น alert) = ไม่เติม ปล่อยว่าง
    const hasOwnContact = ["contact_name", "contact_phone", "contact_line", "contact_email"].some((k) => !!detail?.[k]);
    let projectContact = null;
    if (!hasOwnContact && !this.isCustomer) {
      const settingRes = await GET("api/admin/sale-project-settings", null, false);
      if (settingRes?.status) projectContact = settingRes.data || null;
    }
    const contactSource = hasOwnContact ? detail : projectContact;
    loading(false);

    // ★ ประกาศใหม่/ประกาศเก่าที่ยังไม่มีข้อมูลตัวทรัพย์ เติมค่าตั้งต้นจากทะเบียนห้องให้
    //   แอดมินไม่ต้องพิมพ์ซ้ำสิ่งที่ระบบรู้อยู่แล้ว (อาคาร/ชั้น/พื้นที่/เลขที่ห้อง)
    const fallback = (value, alt) => (value === null || value === undefined || value === "" ? alt : value);

    this.setState({
      loaded: true,
      room,
      contactFromProject: !hasOwnContact && !!projectContact && ["contact_name", "contact_phone", "contact_line", "contact_email"].some((k) => !!projectContact[k]),
      form: {
        ...EMPTY_FORM,
        listing_uid: listing?.uid || "",
        customer_id: room?.customer_id || "",

        listing_type: detail?.listing_type || "ขาย",
        // ประกาศเก่าที่ยังไม่มีวันเริ่มประกาศ ใช้วันที่เริ่มขายแทน (ตรงกับที่ migration backfill ไว้)
        announce_start_at: toDateTimeInput(detail?.announce_start_at || detail?.selling_at),
        announce_end_at: toDateTimeInput(detail?.announce_end_at),
        price: detail?.price ? String(Number(detail.price)) : "",
        selling_status: detail?.selling_status || "ว่าง",
        selling_at: toDateTimeInput(detail?.selling_at),
        sold_at: toDateTimeInput(detail?.sold_at),
        selling_reason: detail?.selling_reason || "",
        commission: detail?.commission ? String(Number(detail.commission)) : "",
        rent_commission_method: detail?.rent_commission_method || "กำหนดรูปแบบค่าดำเนินการ",

        rent_price: detail?.rent_price ? String(Number(detail.rent_price)) : "",
        rent_status: detail?.rent_status || "",
        rent_deposit: detail?.rent_deposit ? String(Number(detail.rent_deposit)) : "",
        rent_start_at: toDateTimeInput(detail?.rent_start_at),
        rent_end_at: toDateTimeInput(detail?.rent_end_at),
        rent_reason: detail?.rent_reason || "",
        sell_with_tenant: !!detail?.sell_with_tenant,
        tenant_name: detail?.tenant_name || "",
        tenant_phone: detail?.tenant_phone || "",
        tenant_notified: !!detail?.tenant_notified,

        reserve_name: detail?.reserve_name || "",
        reserve_phone: detail?.reserve_phone || "",
        reserve_at: toDateTimeInput(detail?.reserve_at),
        reserve_expire_at: toDateTimeInput(detail?.reserve_expire_at),
        reserve_note: detail?.reserve_note || "",

        contact_name: contactSource?.contact_name || "",
        contact_phone: contactSource?.contact_phone || "",
        contact_line: contactSource?.contact_line || "",
        contact_email: contactSource?.contact_email || "",

        property_type: detail?.property_type || DEFAULT_PROPERTY_TYPE,
        building_no: fallback(detail?.building_no, room?.building ? `อาคาร ${room.building}` : ""),
        floor: fallback(detail?.floor, room?.floor ? `ชั้น ${room.floor}` : ""),
        usable_area: String(fallback(detail?.usable_area, room?.room_size || "") || ""),
        land_area: detail?.land_area ? String(detail.land_area) : "",
        bedroom_count: detail?.bedroom_count ? String(detail.bedroom_count) : "",
        bathroom_count: detail?.bathroom_count ? String(detail.bathroom_count) : "",
        parking_count: detail?.parking_count ? String(detail.parking_count) : "",

        address_number: room?.address_number || detail?.address_number || "",
        building_name: fallback(detail?.building_name, room?.project_name || ""),
        address_moo: detail?.address_moo || "",
        address_soi: detail?.address_soi || "",
        address_road: detail?.address_road || "",
        address_subdistrict: detail?.address_subdistrict || "",
        address_district: detail?.address_district || "",
        address_province: detail?.address_province || "",
        address_postcode: detail?.address_postcode || "",
        map_url: detail?.map_url || "",

        highlight: detail?.highlight || "",
        facilities: detail?.facilities
          ? String(detail.facilities).split(",").map((i) => i.trim()).filter(Boolean)
          : [],
        description: detail?.description || "",
        images: Array.isArray(detail?.images) ? detail.images.filter(Boolean) : [],
        // ห้องที่ยังไม่เคยลงประกาศ ตั้งต้นเป็นเผยแพร่ (ลงประกาศ = ขึ้นเว็บ)
        is_published: listing ? !!detail?.is_published : true,
        publish_status: detail?.publish_status || "",
        remark: detail?.remark || "",
      },
    });
  };

  // ---------- ฟอร์ม ----------

  setField = (key, value) => {
    this.setState((prev) => {
      const form = { ...prev.form, [key]: value };
      // เปลี่ยนเป็นประกาศที่มีการเช่า ต้องมีสถานะเช่าเสมอ
      if (key === "listing_type" && value !== "ขาย" && !form.rent_status) form.rent_status = "ว่าง";
      // ขายพร้อมผู้เช่า = ห้องมีผู้เช่าอยู่จริง
      if (key === "sell_with_tenant" && value === true && form.rent_status !== "ให้เช่าแล้ว") form.rent_status = "ให้เช่าแล้ว";
      // เลือกรูปแบบค่าตอบแทน "1 เดือน" (ค่าคงที่) แล้ว — เลิกใช้ตัวเลขที่กรอกเอง กันค่าเก่าค้าง
      if (key === "rent_commission_method" && value === "ค่าตอบแทนค่าดำเนินการ 1 เดือน") form.commission = "";
      return { form };
    });
  };

  // ปุ่มประเภทประกาศ — ตั้ง listing_type กับ sell_with_tenant พร้อมกัน (ดู LISTING_CHOICES)
  pickListingChoice = (choice) => {
    this.setState((prev) => {
      const form = { ...prev.form, listing_type: choice.listing_type, sell_with_tenant: choice.sell_with_tenant };
      if (choice.listing_type !== "ขาย" && !form.rent_status) form.rent_status = "ว่าง";
      if (choice.sell_with_tenant) form.rent_status = "ให้เช่าแล้ว";
      return { form };
    });
  };

  currentChoiceKey = () => {
    const { form } = this.state;
    if (form.sell_with_tenant && form.listing_type === "ขาย") return "ขายพร้อมผู้เช่า";
    return form.listing_type;
  };

  // ---------- ที่อยู่ (จังหวัด > อำเภอ > ตำบล) ----------

  districtList = () =>
    this.state.provinces.find((item) => item.th === this.state.form.address_province)?.district || [];

  subDistrictList = () =>
    this.districtList().find((item) => item.th === this.state.form.address_district)?.sub_district || [];

  // ★ เปลี่ยนระดับบน ต้องล้างระดับล่างทิ้ง ไม่งั้นจะได้ "ตำบลของอำเภอเก่า" ค้างอยู่กับจังหวัดใหม่
  setProvince = (value) =>
    this.setState((prev) => ({
      form: { ...prev.form, address_province: value, address_district: "", address_subdistrict: "", address_postcode: "" },
    }));

  setDistrict = (value) =>
    this.setState((prev) => ({
      form: { ...prev.form, address_district: value, address_subdistrict: "", address_postcode: "" },
    }));

  // ตำบลมีรหัสไปรษณีย์ติดมาด้วย เติมให้เลย (ยังแก้เองได้ถ้าที่อยู่จริงใช้คนละรหัส)
  setSubDistrict = (value) =>
    this.setState((prev) => {
      const found = this.subDistrictList().find((item) => item.th === value);
      return {
        form: {
          ...prev.form,
          address_subdistrict: value,
          address_postcode: found?.code ? String(found.code) : prev.form.address_postcode,
        },
      };
    });

  // dropdown ที่อยู่ 1 ช่อง
  // ★ ค่าที่บันทึกไว้เดิมแต่ไม่มีในลิสต์ (พิมพ์เองสมัยก่อน) ต้องยังเห็นอยู่ ไม่งั้นเปิดมาแล้วช่องว่างเปล่า
  addressSelect = (key, label, options, onChange, opts = {}) => {
    const value = this.state.form[key];
    const names = options.map((item) => item.th);
    const list = value && !names.includes(value) ? [value, ...names] : names;

    return (
      <div className="pf-section">
        <label className="prop-label">
          {label}
          {opts.required && <span className="pf-req">*</span>}
        </label>
        <select
          className="prop-field prop-select"
          disabled={opts.disabled || this.isLocked()}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">{opts.placeholder || "เลือก"}</option>
          {list.map((item) => (
            <option key={item} value={item}>{item}</option>
          ))}
        </select>
        {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
      </div>
    );
  };

  // จังหวัด — ค้นหาในตัวเลือกได้ (77 จังหวัด เลื่อนหาทีละบรรทัดช้า) ใช้คอมโพเนนต์ Select ตัวเดียวกับหน้าอื่น
  // ★ ค่าเดิมที่ไม่มีในลิสต์ (พิมพ์เองสมัยก่อน) ต้องยังเห็นอยู่ เหมือน addressSelect
  provinceSelect = () => {
    const value = this.state.form.address_province;
    const names = this.state.provinces.map((item) => item.th);
    const list = value && !names.includes(value) ? [value, ...names] : names;
    const options = list.map((th) => ({ value: th, label: th }));

    return (
      <div className="pf-section">
        <label className="prop-label">
          จังหวัด
          <span className="pf-req">*</span>
        </label>
        <Select
          className="prop-field prop-select"
          placeholder="ค้นหา / เลือกจังหวัด"
          disabled={this.isLocked()}
          value={value}
          options={options}
          onChange={(v) => this.setProvince(v)}
        />
      </div>
    );
  };

  toggleFacility = (name) => {
    this.setState((prev) => ({
      form: {
        ...prev.form,
        facilities: prev.form.facilities.includes(name)
          ? prev.form.facilities.filter((i) => i !== name)
          : [...prev.form.facilities, name],
      },
    }));
  };

  pickImages = async (event) => {
    if (!event.target.files?.length) return;

    const picked = Array.from(event.target.files);
    event.target.value = "";

    // ไฟล์ใหญ่เกิน = ไม่รับ และบอกชื่อไฟล์ให้รู้ว่าตัวไหน (ย่อทีหลังไม่ช่วย ตอนอ่านไฟล์ก็หนักแล้ว)
    const tooLarge = picked.filter((file) => file.size > MAX_IMAGE_MB * 1024 * 1024);
    if (tooLarge.length) {
      await alert(
        "",
        "warning",
        "ไฟล์ใหญ่เกินไป",
        `รูปต้องมีขนาดไม่เกิน ${MAX_IMAGE_MB} MB ต่อรูป — ${tooLarge.map((f) => f.name).join(", ")}`
      );
    }

    const files = picked.filter((file) => file.size <= MAX_IMAGE_MB * 1024 * 1024);
    if (!files.length) return;

    // เกินโควตา = รับเท่าที่เหลือ แล้วบอกว่าเหลือกี่ใบ (ดีกว่าปฏิเสธทั้งชุดแล้วให้เลือกใหม่)
    const room = MAX_IMAGES - this.state.form.images.length;
    if (room <= 0) {
      await alert("", "warning", "รูปครบแล้ว", `ใส่รูปได้สูงสุด ${MAX_IMAGES} รูปต่อห้อง กรุณาลบรูปเดิมก่อน`);
      return;
    }
    if (files.length > room) {
      await alert("", "warning", "รูปเกินจำนวน", `ใส่รูปได้สูงสุด ${MAX_IMAGES} รูปต่อห้อง — รับเพิ่มได้อีก ${room} รูป`);
    }

    const accepted = files.slice(0, room);
    const resized = await Promise.all(
      accepted.map(
        (file) =>
          new Promise((resolve) => {
            Resizer.imageFileResizer(file, IMAGE_RESIZE_PX, IMAGE_RESIZE_PX, "JPEG", 90, 0, (uri) => resolve(uri), "base64");
          })
      )
    );
    this.setState((prev) => ({ form: { ...prev.form, images: [...prev.form.images, ...resized] } }));
  };

  // เลื่อนรูปขึ้นเป็นหน้าปก — รูปแรกคือรูปที่โผล่บนการ์ดหน้าเว็บ
  makeCover = (index) => {
    this.setState((prev) => {
      const images = [...prev.form.images];
      const [picked] = images.splice(index, 1);
      return { form: { ...prev.form, images: [picked, ...images] }, activeImage: 0 };
    });
  };

  removeImage = (index) =>
    this.setState((prev) => {
      const images = prev.form.images.filter((_, i) => i !== index);
      return { form: { ...prev.form, images }, activeImage: Math.max(0, Math.min(prev.activeImage, images.length - 1)) };
    });

  moveImage = (step) =>
    this.setState((prev) => {
      const total = prev.form.images.length;
      if (!total) return null;
      return { activeImage: (prev.activeImage + step + total) % total };
    });

  // ★ ส่งให้ผู้ดูแลตรวจแล้ว (รอเผยแพร่) หรืออนุมัติขึ้นเว็บแล้ว (เผยแพร่) — เจ้าของห้องแก้อะไรไม่ได้อีก
  //   ระหว่างรอตรวจต้องล็อกด้วย ไม่งั้นผู้ดูแลตรวจข้อมูลชุดหนึ่ง แต่ของจริงถูกแก้ไปแล้วอีกชุด
  //   (backend ปฏิเสธซ้ำอีกชั้น ดู GB_SALE_LISTING_PUBLISHED_LOCKED ใน sale-listing.service.js)
  isCustomerLocked = () =>
    this.isCustomer &&
    [PUBLISH_STATUS.PENDING, PUBLISH_STATUS.PUBLISHED].includes(this.state.form.publish_status);

  // สิทธิ์เขียนประกาศใบนี้ — ลงประกาศใหม่ใช้ .create แก้ไข/อนุมัติใช้ .update (ตรงกับ sale-listing.route.js)
  canWrite = () => hasPermission(this.state.form.listing_uid ? "sale-listing.update" : "sale-listing.create");

  // ช่องกรอกทั้งหน้า disable เมื่อ : เจ้าของห้องส่งตรวจ/เผยแพร่แล้ว หรือ ผู้ใช้ไม่มีสิทธิ์เขียน
  isLocked = () => this.isCustomerLocked() || !this.canWrite();

  // ---------- ตรวจฟอร์ม ----------

  // คืนข้อความ error ถ้ายังกรอกไม่ครบ (null = ผ่าน)
  // ★ ใช้เช็คตอน "บันทึก" ทุกปุ่มที่ไม่ใช่แบบร่าง ทั้งสองฝั่ง (ดู save) และตอน "อนุมัติ (เผยแพร่)" (ดู setPublish)
  validate = () => {
    const { form } = this.state;
    if (hasSale(form.listing_type) && !Number(form.price)) return "กรุณาระบุราคาขาย";
    if ((hasRent(form.listing_type) || form.sell_with_tenant) && !Number(form.rent_price)) {
      return "กรุณาระบุค่าเช่าต่อเดือน";
    }
    // ช่วงประกาศกลับหัวกลับหาง = ประกาศจบก่อนเริ่ม ไม่มีวันขึ้นหน้าเว็บ
    if (form.announce_start_at && form.announce_end_at && form.announce_end_at < form.announce_start_at) {
      return "วันที่สิ้นสุดเผยแพร่ต้องไม่น้อยกว่าวันที่เริ่มเผยแพร่";
    }
    // ขายพร้อมผู้เช่าโดยไม่บอกว่าสัญญาจบเมื่อไร ผู้ซื้อตัดสินใจไม่ได้
    if (form.sell_with_tenant && !form.rent_end_at) return "ขายพร้อมผู้เช่า ต้องระบุวันสิ้นสุดสัญญาเช่า";
    if (form.sell_with_tenant && !form.tenant_name.trim()) return "ขายพร้อมผู้เช่า ต้องระบุชื่อผู้เช่าปัจจุบัน";

    // ★ ข้อมูลทรัพย์ที่ผู้ซื้อใช้ตัดสินใจ — ประกาศที่ขาดชุดนี้ขึ้นหน้าเว็บแล้วอ่านไม่รู้เรื่อง
    if (!Number(form.usable_area)) return "ห้องนี้ยังไม่มีพื้นที่ใช้สอยในทะเบียนลูกบ้าน กรุณากรอกที่หน้าข้อมูลลูกบ้านก่อน";
    if (!form.address_subdistrict.trim()) return "กรุณาระบุแขวง / ตำบล";
    if (!form.address_district.trim()) return "กรุณาระบุเขต / อำเภอ";
    if (!form.address_province.trim()) return "กรุณาระบุจังหวัด";
    if (!form.address_postcode.trim()) return "กรุณาระบุรหัสไปรษณีย์";
    return null;
  };

  cancel = () => (window.location.href = "/project-room-all");

  // draft  = true : "บันทึกร่าง" — เก็บข้อมูลไว้ก่อนโดยไม่เช็คว่ากรอกครบ และไม่แตะสถานะเผยแพร่
  // silent = true : บันทึกเป็นขั้นตอนกลางของงานอื่น (ปุ่ม "ส่งข้อมูล") — ไม่เด้ง alert / ไม่โหลดหน้าใหม่
  //                 คืน true/false ให้ผู้เรียกตัดสินใจทำขั้นต่อไป
  // publish : เฉพาะฝั่งผู้ดูแลตอนสร้างประกาศใหม่ (ยังไม่มี listing_uid เรียก setPublish ไม่ได้)
  //           true = "อนุมัติ (เผยแพร่)" ส่งค่าเผยแพร่ไปพร้อมตอนสร้างเลย / false = "บันทึก" ไม่เผยแพร่
  save = async ({ draft = false, silent = false, publish } = {}) => {
    const { form } = this.state;

    // ★ ดักช่องบังคับ (*) ทุกปุ่มบันทึก ทั้งฝั่งผู้ดูแลและเจ้าของห้อง
    //   เดิมดักเฉพาะเจ้าของห้อง ผู้ดูแลกด "บันทึก" / "บันทึกการแก้ไข" / "อนุมัติ (เผยแพร่)" ตอนสร้างใหม่
    //   ผ่านไปได้ทั้งที่จังหวัด/อำเภอ/ตำบล/รหัสไปรษณีย์ยังว่าง — มี * แต่ไม่บังคับจริง
    //   (ปุ่มอนุมัติของประกาศเดิมตรวจใน setPublish อยู่แล้ว แต่ประกาศใหม่อนุมัติผ่าน save ตรงนี้)
    //   แบบร่างไม่ดัก — จุดประสงค์คือเก็บของที่ยังกรอกไม่เสร็จ
    //   backend ยังตรวจชนิดข้อมูลอยู่ (ประเภททรัพย์ / ตัวเลขติดลบ / ช่วงวันประกาศ)
    if (!draft) {
      const error = this.validate();
      if (error) {
        await alert("", "warning", "แจ้งเตือน", error);
        return false;
      }
    }

    // ★ รูปส่งเป็น base64 ตรง ๆ ได้ backend อัปขึ้น S3 ให้เอง (ProcessFile)
    //   URL เดิมที่ส่งกลับไปจะไม่ถูกอัปซ้ำ
    const body = {
      listing_type: form.listing_type,
      announce_start_at: toApiDateTime(form.announce_start_at),
      announce_end_at: toApiDateTime(form.announce_end_at),
      price: Number(form.price) || 0,
      selling_status: form.selling_status,
      selling_at: toApiDateTime(form.selling_at),
      sold_at: toApiDateTime(form.sold_at),
      selling_reason: form.selling_reason || null,
      commission: form.commission !== "" ? Number(form.commission) : null,
      rent_commission_method: form.rent_commission_method || null,

      rent_price: Number(form.rent_price) || 0,
      rent_status: form.rent_status || null,
      rent_deposit: Number(form.rent_deposit) || 0,
      rent_start_at: toApiDateTime(form.rent_start_at),
      rent_end_at: toApiDateTime(form.rent_end_at),
      rent_reason: form.rent_reason || null,
      sell_with_tenant: !!form.sell_with_tenant,
      tenant_name: form.tenant_name || null,
      tenant_phone: form.tenant_phone || null,
      tenant_notified: !!form.tenant_notified,

      // ★ การ์ด "ข้อมูลการจอง" ถูกเอาออกจากหน้าจอแล้ว แต่ยังส่งค่าที่โหลดมากลับไปตามเดิม
      //   ไม่งั้นการกดบันทึกจะล้างข้อมูลการจองที่มีอยู่ทิ้งโดยไม่มีใครสั่ง
      reserve_name: form.reserve_name || null,
      reserve_phone: form.reserve_phone || null,
      reserve_at: toApiDateTime(form.reserve_at),
      reserve_expire_at: toApiDateTime(form.reserve_expire_at),
      reserve_note: form.reserve_note || null,

      contact_name: form.contact_name || null,
      contact_phone: form.contact_phone || null,
      contact_line: form.contact_line || null,
      contact_email: form.contact_email || null,

      property_type: form.property_type || null,
      building_no: form.building_no || null,
      floor: form.floor || null,
      usable_area: toApiNumber(form.usable_area),
      land_area: toApiNumber(form.land_area),
      bedroom_count: toApiNumber(form.bedroom_count),
      bathroom_count: toApiNumber(form.bathroom_count),
      parking_count: toApiNumber(form.parking_count),

      building_name: form.building_name || null,
      address_moo: form.address_moo || null,
      address_soi: form.address_soi || null,
      address_road: form.address_road || null,
      address_subdistrict: form.address_subdistrict || null,
      address_district: form.address_district || null,
      address_province: form.address_province || null,
      address_postcode: form.address_postcode || null,
      map_url: form.map_url || null,

      highlight: form.highlight || null,
      facilities: form.facilities.join(","),
      description: form.description || null,
      images: form.images,
      remark: form.remark || null,
    };

    // ★ สถานะการเผยแพร่เปลี่ยนได้จากปุ่มเฉพาะทางเท่านั้น (ส่งข้อมูล / อนุมัติ / ไม่อนุมัติ)
    //   ปุ่มบันทึกทั้งสองฝั่งจึงไม่ส่ง is_published ไปเลย — กดบันทึกแล้วสถานะต้องไม่ขยับ
    // ★ ประกาศใบใหม่ที่ลูกบ้านกด "บันทึกแบบร่าง" ต้องไม่หลุดเข้าคิวรอผู้ดูแล
    //   (backend ตั้งประกาศที่ลูกบ้านสร้างเป็น "รอเผยแพร่" ให้อัตโนมัติ ถ้าไม่ส่งค่านี้มา)
    //   ประกาศที่มีอยู่แล้วไม่ต้องส่ง สถานะเดิมจะไม่ถูกแตะ
    if (this.isCustomer && draft && !form.listing_uid) body.is_published = false;

    // ★ ผู้ดูแลลงประกาศใหม่ : "บันทึก" (publish=false) ไม่ขึ้นเว็บ / "อนุมัติ (เผยแพร่)" (publish=true) ขึ้นเว็บทันที
    if (!this.isCustomer && !form.listing_uid && publish !== undefined) body.is_published = publish;

    this.setState({ saving: true });
    loading(true);
    const result = form.listing_uid
      ? await PUT("api/admin/sale-listings/" + form.listing_uid, body)
      : await POST("api/admin/sale-listings", { customer_list: [{ customer_id: form.customer_id, ...body }] });
    loading(false);
    this.setState({ saving: false });

    if (!result?.status) return false;
    if (silent) return true;

    await alert("", "success", "สำเร็จ", draft ? "บันทึกร่างเรียบร้อย" : publish ? "อนุมัติประกาศเรียบร้อย" : "บันทึกข้อมูลทรัพย์เรียบร้อย");

    // ★ ลูกบ้านไม่มีหน้ารายการให้กลับไป (เข้าเมนูแล้วเด้งมาหน้านี้ตรง ๆ) — โหลดข้อมูลใหม่แล้วอยู่หน้าเดิม
    if (this.isCustomer) {
      await this.load();
      return true;
    }
    window.location.href = "/project-room-all";
    return true;
  };

  // ---------- ส่งข้อมูลให้ผู้ดูแลตรวจ (ฝั่งลูกบ้าน) ----------
  //
  // บันทึกข้อมูลก่อน แล้วค่อยเปลี่ยนสถานะเป็น "รอเผยแพร่" — สองอย่างในปุ่มเดียว
  // ★ ถามยืนยันครั้งเดียวตรงนี้ แล้วสั่ง setPublish แบบข้ามการถามซ้ำ
  // ★ ประกาศใหม่ (ยังไม่มี listing_uid) : save() เพิ่งเป็นคน POST สร้างประกาศ ตอนนั้นยังเรียก
  //   setPublish ไม่ได้ (endpoint publish ต้องมี uid) — แต่ backend ตั้ง publish_status เป็น
  //   "รอเผยแพร่" ให้อัตโนมัติอยู่แล้วเมื่อลูกบ้านสร้างประกาศโดยไม่ส่ง is_published มา (ดู save())
  //   จึงแค่แจ้งผลแล้วโหลดข้อมูลใหม่ ไม่ต้องเรียก setPublish ซ้ำ
  submitForReview = async () => {
    const error = this.validate();
    if (error) return alert("", "warning", "แจ้งเตือน", error);

    const confirmed = await alert(
      "",
      "warning",
      "ส่งข้อมูลให้ผู้ดูแลตรวจ",
      `ระบบจะบันทึกข้อมูลล่าสุด แล้วเปลี่ยนสถานะเป็น "${PUBLISH_STATUS.PENDING}" · ระหว่างรอผู้ดูแลตรวจ ประกาศจะยังไม่ขึ้นหน้าเว็บ`,
      "ยืนยันส่งข้อมูล",
      "ยกเลิก"
    );
    if (!confirmed) return;

    const isNewListing = !this.state.form.listing_uid;
    const saved = await this.save({ silent: true });
    if (!saved) return;

    if (isNewListing) {
      await alert("", "success", "สำเร็จ", "รอผู้ดูแลตรวจสอบและติดต่อกลับ");
      await this.load();
      return;
    }

    await this.setPublish(true, { skipConfirm: true, doneMessage: "ส่งข้อมูลให้ผู้ดูแลแล้ว" });
  };

  // ---------- อนุมัติ / ไม่อนุมัติ ----------
  //
  // ★ ใช้ API เดียวกับปุ่มบนหน้ารายการ (PUT /sale-listings/publish)
  //   backend เป็นคนตัดสินสถานะสุดท้าย — ลูกค้ากดเองได้แค่ "รอเผยแพร่" (ดู syncPublishState)
  //
  // ★ ผู้ดูแล : บันทึกฟอร์มก่อน (save silent) แล้วค่อยเปลี่ยนสถานะ — เหมือน submitForReview ฝั่งลูกบ้าน
  //   เดิมยิงแค่ /publish แล้ว load() ทับฟอร์ม ราคา/สถานะที่แก้แต่ยังไม่กดบันทึกหายเงียบ
  //   และ validate() ตรวจฟอร์มบนจอ แต่สิ่งที่ขึ้นเว็บคือข้อมูลเก่าใน DB
  //   "ไม่อนุมัติ" บันทึกแบบร่าง (ไม่ตรวจความครบ) — ปิดการเผยแพร่ต้องทำได้เสมอแม้ข้อมูลยังไม่ครบ
  setPublish = async (isPublished, { skipConfirm = false, doneMessage = "" } = {}) => {
    const { form, publishing } = this.state;
    if (!form.listing_uid || publishing) return;

    // ★ กันอนุมัติ/ขอเผยแพร่ทั้งที่ข้อมูลบังคับ (*) ยังไม่ครบ — ใช้เกณฑ์เดียวกับ validate() ด้านบน
    //   (จังหวัด / เขต-อำเภอ / แขวง-ตำบล / รหัสไปรษณีย์ ฯลฯ) ไม่แยกรายการช่องบังคับใหม่
    //   "ไม่อนุมัติ" (isPublished = false) ไม่เช็ค — ปิดการเผยแพร่ทำได้เสมอไม่ว่าข้อมูลจะครบหรือไม่
    if (isPublished) {
      const error = this.validate();
      if (error) {
        await alert("", "warning", "แจ้งเตือน", error);
        return;
      }
    }

    // ★ ปุ่มเดียวกันคนละความหมายตามบทบาท — ลูกบ้าน "ขอ" เผยแพร่ (เข้าคิวรอ) ผู้ดูแล "อนุมัติ" (ขึ้นเว็บจริง)
    const text = this.isCustomer
      ? {
          title: isPublished ? "ส่งประกาศให้ผู้ดูแลตรวจ" : "ยกเลิกการเผยแพร่",
          detail: isPublished
            ? "ประกาศจะเข้าคิวรอผู้ดูแลอนุมัติ ยังไม่ขึ้นหน้าเว็บทันที"
            : "ประกาศจะถูกถอนออกจากคิวรอผู้ดูแล และไม่แสดงบนหน้าเว็บ",
          done: isPublished ? "ส่งประกาศให้ผู้ดูแลแล้ว" : "ยกเลิกการเผยแพร่แล้ว",
        }
      : {
          title: isPublished ? "อนุมัติประกาศนี้" : "ไม่อนุมัติประกาศนี้",
          detail: isPublished
            ? "ประกาศจะขึ้นหน้าเว็บสาธารณะทันทีหลังกดยืนยัน"
            : "ประกาศจะถูกปิดการเผยแพร่ ไม่แสดงบนหน้าเว็บสาธารณะ",
          done: isPublished ? "อนุมัติประกาศเรียบร้อย" : "ปิดการเผยแพร่ประกาศแล้ว",
        };

    if (!skipConfirm) {
      const confirmed = await alert("", "warning", text.title, text.detail, "ยืนยัน", "ยกเลิก");
      if (!confirmed) return;
    }

    this.setState({ publishing: true });

    // ลูกบ้านมาจาก submitForReview ซึ่งบันทึกไปแล้ว — ไม่บันทึกซ้ำ
    if (!this.isCustomer) {
      const saved = await this.save({ silent: true, draft: !isPublished });
      if (!saved) {
        this.setState({ publishing: false });
        return;
      }
    }

    loading(true);
    const result = await PUT("api/admin/sale-listings/publish", {
      uid_list: [form.listing_uid],
      is_published: isPublished,
    });
    loading(false);
    this.setState({ publishing: false });
    // ★ ไม่สำเร็จ (เช่น 400 ข้อมูลไม่ครบสำหรับเผยแพร่) PUT แสดงข้อความจาก backend ให้แล้ว
    //   ข้อมูลในฟอร์มถูกบันทึกไปแล้ว ไม่ต้อง load() ทับ
    if (!result?.status) return;

    await alert("", "success", "สำเร็จ", doneMessage || text.done);
    await this.load();
  };

  // ---------- ชิ้นส่วนฟอร์มที่ใช้ซ้ำ ----------

  card = (title, body, extra) => (
    <div className="prop-card prop-in">
      <div className="prop-card__head">
        <span className="prop-title text-16">
          <span className="prop-title__dot" />
          {title}
        </span>
        {extra}
      </div>
      <div className="p-4">{body}</div>
    </div>
  );

  // ★ ช่องตัวเลข/จำนวนทุกช่องใช้ NumericFormat — มีตัวคั่นหลักพันให้อ่านง่าย และพิมพ์ตัวอักษรลงไปไม่ได้
  //   ค่าที่เก็บใน state ยังเป็นตัวเลขล้วน (v.value) ไม่ติดคอมมา ส่งเข้า Number() ได้ตรง ๆ
  //   decimalScale: ราคา/พื้นที่ = 2 ตำแหน่ง, จำนวนห้อง/คัน = จำนวนเต็ม (ส่ง opts.decimalScale = 0)
  input = (key, label, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">
        {label}
        {opts.required && <span className="pf-req">*</span>}
      </label>
      {opts.type === "number" ? (
        <NumericFormat
          className="prop-field"
          type="text"
          inputMode="decimal"
          thousandSeparator=","
          allowNegative={false}
          decimalScale={opts.decimalScale === undefined ? 2 : opts.decimalScale}
          placeholder={opts.placeholder || ""}
          disabled={opts.disabled || this.isLocked()}
          value={this.state.form[key]}
          onValueChange={(v) => this.setField(key, v.value)}
        />
      ) : (
        <input
          className="prop-field"
          type={opts.type || "text"}
          inputMode={opts.phone ? "numeric" : undefined}
          placeholder={opts.placeholder || ""}
          maxLength={opts.phone ? 10 : opts.maxLength}
          disabled={opts.disabled || this.isLocked()}
          value={this.state.form[key]}
          // ★ ช่องเบอร์โทร : ตัวเลขล้วน ไม่เกิน 10 หลัก (กันทั้งพิมพ์และวางจากคลิปบอร์ด)
          onChange={(e) => this.setField(key, opts.phone ? onlyPhoneDigits(e.target.value) : e.target.value)}
        />
      )}
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  // ★ ทุกช่อง "วันที่ + เวลา" ในหน้านี้ใช้ DateTimePicker กลาง (CustomComponent) ห้ามใช้ datetime-local
  //   เหตุผล : native datetime-local แสดงวันที่ตาม locale ของเบราว์เซอร์ คุมรูปแบบจากโค้ดไม่ได้
  //   ค่าที่เก็บใน state ยังเป็น "YYYY-MM-DDTHH:mm" เหมือนเดิม (toApiDateTime/toDateTimeInput ไม่ต้องแก้)
  dateTimeField = (key, label, opts = {}) => {
    const raw = this.state.form[key] || "";
    const disabled = opts.disabled || this.isLocked();
    return (
      <div className="pf-section">
        <label className="prop-label">
          {label}
          {opts.required && <span className="pf-req">*</span>}
        </label>
        <DateTimePicker
          className="prop-field"
          value={raw}
          disabled={disabled}
          onChange={(v) => this.setField(key, v)}
        />
        {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
      </div>
    );
  };

  select = (key, label, options, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">
        {label}
        {opts.required && <span className="pf-req">*</span>}
      </label>
      <select
        className="prop-field prop-select"
        disabled={this.isLocked()}
        value={this.state.form[key]}
        onChange={(e) => this.setField(key, e.target.value)}
      >
        {opts.allowEmpty && <option value="">ไม่ระบุ</option>}
        {options.map((i) => (
          <option key={i} value={i}>{i}</option>
        ))}
      </select>
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  textarea = (key, label, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">{label}</label>
      <textarea
        className="prop-field"
        rows={opts.rows || 4}
        style={{ height: "auto", padding: "10px 14px" }}
        placeholder={opts.placeholder || ""}
        disabled={opts.disabled || this.isLocked()}
        value={this.state.form[key]}
        onChange={(e) => this.setField(key, e.target.value)}
      />
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  // แถวปุ่มเลือกค่าเดียว (สถานะทรัพย์ / สถานะการแจ้งผู้เช่า)
  chips = (key, label, options, opts = {}) => (
    <div className="pf-section">
      <label className="prop-label">{label}</label>
      <div className="pf-chips">
        {options.map((item) => (
          <button
            key={String(item.value)}
            type="button"
            aria-pressed={this.state.form[key] === item.value}
            className={`pf-chip ${this.state.form[key] === item.value ? "is-active" : ""}`}
            disabled={this.isLocked()}
            onClick={() => this.setField(key, item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
      {!!opts.hint && <div className="pf-hint">{opts.hint}</div>}
    </div>
  );

  // ---------- ซ้าย : ข้อมูลประกาศ ----------

  renderListingType = () =>
    this.card(
      "ประเภทประกาศ",
      <>
        <div className="pf-chips">
          {LISTING_CHOICES.filter((item) => !item.legacy || this.currentChoiceKey() === item.key).map((item) => (
            <button
              key={item.key}
              type="button"
              aria-pressed={this.currentChoiceKey() === item.key}
              className={`pf-chip ${this.currentChoiceKey() === item.key ? "is-active" : ""}`}
              disabled={this.isLocked()}
              onClick={() => this.pickListingChoice(item)}
            >
              {item.label}
            </button>
          ))}
        </div>
        <div className="pf-hint">ตัวเลือกนี้กำหนดว่าจะแสดงกลุ่มข้อมูลใดต่อไป</div>
      </>
    );

  renderSaleCard = () => {
    const { form } = this.state;
    // ★ 2 คอลัมน์บนจอกว้าง ยุบเป็นคอลัมน์เดียวบนจอเล็ก (col-md-6) — ฟอร์มจะได้ไม่ยาวจนต้องเลื่อนหลายจอ
    return this.card(
      "ข้อมูลการขาย",
      <div className="row g-3">
        <div className="col-12 col-md-6">{this.input("price", "ราคาขาย (บาท)", { type: "number", required: true })}</div>
        <div className="col-12 col-md-6">
          {this.input("commission", "ค่าดำเนินการ (บาท)", { type: "number", placeholder: "ระบุจำนวนเงิน" })}
        </div>
        <div className="col-12 col-md-6">{this.input("selling_reason", "เหตุผลที่ขาย", { placeholder: "ระบุเหตุผล" })}</div>
        {form.selling_status === "ขายแล้ว" && (
          <div className="col-12 col-md-6">{this.dateTimeField("sold_at", "วันที่ขายได้")}</div>
        )}
      </div>
    );
  };

  renderRentCard = () => {
    const { form } = this.state;
    const isPureRent = hasRent(form.listing_type) && !hasSale(form.listing_type);
    const isFixedCommission = isPureRent && form.rent_commission_method === "ค่าตอบแทนค่าดำเนินการ 1 เดือน";

    return this.card(
      "ข้อมูลการเช่า",
      <div className="row g-3">
        <div className="col-12 col-md-6">{this.input("rent_price", "ค่าเช่าต่อเดือน (บาท)", { type: "number", required: true })}</div>
        <div className="col-12 col-md-6">{this.input("rent_deposit", "เงินประกัน (บาท)", { type: "number" })}</div>
        {/* ★ commission เป็นฟิลด์เดียวใน DB — ประกาศที่มีฝั่งขายด้วย (เช่น ขายพร้อมผู้เช่า)
            ให้กรอกที่การ์ด "ข้อมูลการขาย" ที่เดียว ไม่งั้นจะมีช่องค่าดำเนินการโผล่ 2 ที่ผูกค่าเดียวกัน */}
        {isPureRent && (
          <div className="col-12 col-md-6">
            {this.select("rent_commission_method", "รูปแบบค่าตอบแทนผู้ดำเนินการ", RENT_COMMISSION_METHODS)}
          </div>
        )}
        {isPureRent && !isFixedCommission && (
          <div className="col-12 col-md-6">
            {this.input("commission", "ค่าตอบแทนผู้ดำเนินการ (บาท)", {
              type: "number",
              hint: "ปกติเก็บเท่าค่าเช่า 1 เดือน",
            })}
          </div>
        )}
        {isFixedCommission && (
          <div className="col-12">
            <div className="pf-hint">ใช้ค่าเช่า 1 เดือนเป็นค่าตอบแทนผู้ดำเนินการ ไม่ต้องกรอกตัวเลขเอง</div>
          </div>
        )}
        <div className="col-12 col-md-6">{this.select("rent_status", "สถานะการเช่า", RENT_STATUS, { allowEmpty: true })}</div>
        <div className="col-12 col-md-6">{this.input("rent_reason", "เหตุผลที่ปล่อยเช่า", { placeholder: "ระบุเหตุผล" })}</div>
      </div>
    );
  };

  // ผู้เช่าปัจจุบัน — ใช้ทั้ง "ขายพร้อมผู้เช่า" (สัญญาที่ผู้ซื้อต้องรับต่อ) และประกาศเช่าที่มีผู้เช่าอยู่
  renderTenantCard = () => {
    const { form } = this.state;
    const withTenant = form.sell_with_tenant;

    return this.card(
      <>
        {withTenant ? "ผู้เช่าที่ติดมากับการขาย" : "สัญญาเช่าปัจจุบัน"}
        {withTenant && <span className="pf-badge ms-2">เฉพาะประเภทนี้</span>}
      </>,
      <div className="row g-3">
        <div className="col-12 col-md-6">
          {this.input("tenant_name", "ชื่อผู้เช่าปัจจุบัน", { required: withTenant, placeholder: "ระบุชื่อ นามสกุล" })}
        </div>
        <div className="col-12 col-md-6">
          {this.input("tenant_phone", "เบอร์ติดต่อผู้เช่า", { phone: true, placeholder: "0812345678", hint: "ไม่แสดงบนหน้าประกาศ" })}
        </div>
        <div className="col-12 col-md-6">{this.dateTimeField("rent_start_at", "เริ่มสัญญาเช่า")}</div>
        <div className="col-12 col-md-6">
          {this.dateTimeField("rent_end_at", "สิ้นสุดสัญญาเช่า", {
            required: withTenant,
            hint: withTenant ? "ผู้ซื้อต้องรู้ว่าสัญญาเหลืออีกนานแค่ไหน" : "",
          })}
        </div>
        {withTenant && (
          <div className="col-12">
            {this.chips(
              "tenant_notified",
              "สถานะการแจ้งผู้เช่า",
              [
                { value: false, label: "ยังไม่แจ้ง" },
                { value: true, label: "แจ้งแล้ว" },
              ],
              { hint: "ต้องแจ้งผู้เช่าก่อนเผยแพร่ประกาศ" }
            )}
          </div>
        )}
      </div>
    );
  };

  renderAnnounceCard = () =>
    this.card(
      "ช่วงเวลาเผยแพร่",
      <div className="row g-3">
        <div className="col-12 col-md-6">{this.dateTimeField("announce_start_at", "วันที่เริ่มเผยแพร่")}</div>
        <div className="col-12 col-md-6">
          {this.dateTimeField("announce_end_at", "วันที่สิ้นสุดเผยแพร่", {
            hint: "เว้นว่าง = ไม่มีวันหมดอายุ",
          })}
        </div>
      </div>
    );

  // ★ ช่องทางที่ "คนทั่วไป" ใช้ติดต่อผู้ดูแล — ขึ้นกล่อง "ติดต่อสอบถาม / นัดชมทรัพย์" บนหน้าเว็บขาย
  //   ค่าเริ่มต้นมาจาก "การตั้งค่าการขาย (โครงการ) > ข้อมูลติดต่อ Admin"
  //   ว่างทุกช่อง = หน้าเว็บใช้ของโครงการ · ไม่มีทั้งคู่ = ไม่โชว์ช่องทางติดต่อ เหลือแค่ปุ่ม "สนใจทรัพย์นี้"
  renderContactCard = () =>
    this.card(
      "ข้อมูลติดต่อ Admin",
      <>
        {this.state.contactFromProject && (
          <div className="pf-hint mb-2">ดึงค่าเริ่มต้นจากการตั้งค่าการขาย (โครงการ) · แก้เฉพาะประกาศนี้ได้ มีผลเมื่อกดบันทึก</div>
        )}
        <div className="row g-3">
          <div className="col-12 col-md-6">
            {this.input("contact_name", "ชื่อผู้ติดต่อ", { placeholder: "เช่น สมชาย ใจดี (ชาย)" })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("contact_phone", "เบอร์โทรศัพท์", { phone: true, placeholder: "0812345678" })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("contact_line", "LINE", { placeholder: "LINE ID หรือ @official" })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("contact_email", "อีเมล", { type: "email", placeholder: "name@example.com" })}
          </div>
        </div>
        <div className="pf-hint">แสดงบนหน้าประกาศให้คนทั่วไปใช้ติดต่อ · ไม่กรอกเลย = ใช้ข้อมูลติดต่อ Admin ของโครงการ · ไม่มีทั้งคู่ = ไม่แสดงช่องทางติดต่อ</div>
      </>
    );

  // ★ หมายเหตุก้อนนี้เจ้าของห้องเป็นคนเขียนถึงผู้ดูแล ไม่ใช่บันทึกภายในของผู้ดูแล
  //   จึงอยู่บนสุดของหน้า (ผู้ดูแลต้องอ่านก่อนตรวจประกาศ) และผู้ดูแลแก้ไม่ได้
  renderOwnerNoteCard = () =>
    this.card(
      "หมายเหตุจากเจ้าของห้อง",
      this.textarea("remark", "ข้อความถึงผู้ดูแล", {
        rows: 3,
        disabled: !this.isCustomer,
        placeholder: this.isCustomer ? "เขียนสิ่งที่อยากบอกผู้ดูแล" : "— ไม่มีหมายเหตุจากเจ้าของห้อง —",
        hint: this.isCustomer
          ? "ผู้ดูแลเห็นข้อความนี้ตอนตรวจประกาศ · ไม่แสดงบนหน้าเว็บ"
          : "เจ้าของห้องเป็นคนเขียน ผู้ดูแลแก้ไม่ได้ · ไม่แสดงบนหน้าเว็บ",
      })
    );

  // ---------- ขวา : รูปภาพ + ชุดสรุป ----------

  // ★ ชุดสรุปเป็นตัวแสดงผลล้วน อ่านจาก state ของฟอร์มโดยตรง จึงเปลี่ยนตามทันทีที่แก้ฟอร์ม
  //   ค่าที่ยังไม่กรอกต้องขึ้นว่า "ยังไม่ระบุ" ไม่ใช่เว้นว่าง (เว้นว่าง = อ่านเหมือนระบบยังโหลดไม่เสร็จ)
  renderSummary = () => {
    const { form } = this.state;
    const showSale = hasSale(form.listing_type);
    const showRent = hasRent(form.listing_type) || form.sell_with_tenant;

    const blank = <span className="pf-sum__blank">ยังไม่ระบุ</span>;
    const join = (parts) => parts.filter((i) => String(i || "").trim()).join(" · ");

    const specLine = join([
      form.property_type,
      form.building_no,
      form.floor,
      form.usable_area ? `${form.usable_area} ตร.ม.` : "",
      form.bedroom_count ? `${form.bedroom_count} ห้องนอน` : "",
    ]);

    const addressLine1 = [
      form.address_number,
      // ★ ตัดคำ "นิติบุคคล" เฉพาะตอนแสดงผลในชุดสรุป (preview) — ค่าจริงในช่องกรอก building_name ไม่แตะ
      stripJuristic(form.building_name),
      form.address_moo ? `หมู่ ${form.address_moo}` : "",
      form.address_soi ? `ซ.${form.address_soi}` : "",
      form.address_road ? `ถ.${form.address_road}` : "",
      form.address_subdistrict ? `แขวง${form.address_subdistrict}` : "",
    ]
      .filter((i) => String(i || "").trim())
      .join(" ");

    const addressLine2 = [
      form.address_district ? `เขต${form.address_district}` : "",
      form.address_province,
      form.address_postcode,
    ]
      .filter((i) => String(i || "").trim())
      .join(" ");

    // สถานะที่โชว์คู่ชื่อห้อง — ประกาศเช่าใช้สถานะเช่า ประกาศขายใช้สถานะขาย
    const statusText = showSale ? form.selling_status : form.rent_status;

    return (
      <div className="pf-sum" data-testid="listing-summary">
        <div className="pf-sum__title">
          ห้อง {form.address_number || "—"}
          {!!statusText && <span className="pf-sum__status">{statusText}</span>}
        </div>

        <div className="pf-sum__line">{specLine || blank}</div>
        <div className="pf-sum__line">{addressLine1 || blank}</div>
        <div className="pf-sum__line">{addressLine2 || blank}</div>

        <div className="pf-sum__price">
          {showSale && (
            <span className="pf-sum__price-main">
              ขาย {form.price ? `${money(form.price)} บาท` : "ยังไม่ระบุราคา"}
            </span>
          )}
          {showRent && (
            <span className={showSale ? "pf-sum__price-sub" : "pf-sum__price-main"}>
              เช่า {form.rent_price ? `${money(form.rent_price)} บาท / เดือน` : "ยังไม่ระบุราคา"}
            </span>
          )}
        </div>

        {form.sell_with_tenant && (
          <div className="pf-sum__note">
            มีผู้เช่าอยู่ · ค่าเช่า {form.rent_price ? money(form.rent_price) : "—"} บาท/เดือน
            {form.rent_end_at ? ` · สัญญาถึง ${formatSaleDate(form.rent_end_at)}` : " · ยังไม่ระบุวันสิ้นสุดสัญญา"}
          </div>
        )}
        {!form.sell_with_tenant && hasRent(form.listing_type) && !!form.rent_end_at && (
          <div className="pf-sum__note">สัญญาถึง {formatSaleDate(form.rent_end_at)}</div>
        )}
      </div>
    );
  };

  // showSummary = false : ขั้น "รูปภาพ" ของลูกบ้าน — เอาชุดสรุปออก เหลือแค่งานจัดการรูป
  renderMediaCard = ({ showSummary = true } = {}) => {
    const { form, activeImage } = this.state;
    const total = form.images.length;
    const current = form.images[Math.min(activeImage, Math.max(total - 1, 0))];

    return this.card(
      "รูปภาพทรัพย์",
      <>
        <input hidden accept="image/*" id="room-image-input" type="file" multiple onChange={this.pickImages} />

        <div className="pf-gallery">
          {current ? (
            <img src={current} alt={`รูปที่ ${activeImage + 1}`} className="pf-gallery__img" />
          ) : (
            <div className="pf-gallery__ghost icon">{"\uf03e"}</div>
          )}

          {total > 1 && (
            <>
              <button type="button" className="pf-gallery__nav is-prev icon" title="รูปก่อนหน้า" onClick={() => this.moveImage(-1)}>
                {"\uf053"}
              </button>
              <button type="button" className="pf-gallery__nav is-next icon" title="รูปถัดไป" onClick={() => this.moveImage(1)}>
                {"\uf054"}
              </button>
            </>
          )}
          {!!total && <span className="pf-gallery__count">{Math.min(activeImage + 1, total)} / {total}</span>}
        </div>

        <div className="pf-thumbs">
          {form.images.map((image, index) => (
            <div
              key={`thumb-${index}`}
              className={`pf-thumb pf-thumb--sm ${index === activeImage ? "is-active" : ""} ${index === 0 ? "is-cover" : ""}`}
            >
              <img
                src={image}
                alt={`รูปย่อที่ ${index + 1}`}
                className="pf-thumb__img"
                onClick={() => this.setState({ activeImage: index })}
              />
              {index === 0 && <span className="pf-thumb__star icon">{"\uf005"}</span>}
              {!this.isLocked() && (
                <button type="button" className="pf-thumb__x icon" title="ลบรูปนี้" onClick={() => this.removeImage(index)}>
                  {"\uf00d"}
                </button>
              )}
              {!this.isLocked() && index !== 0 && (
                <button type="button" className="pf-thumb__cover" title="ตั้งเป็นรูปหน้าปก" onClick={() => this.makeCover(index)}>
                  ตั้งเป็นปก
                </button>
              )}
            </div>
          ))}
          {!this.isLocked() && form.images.length < MAX_IMAGES && (
            <button
              type="button"
              className="pf-thumb pf-thumb--sm pf-thumb--add icon"
              title="เพิ่มรูปภาพ"
              onClick={() => document.getElementById("room-image-input").click()}
            >
              {"\uf067"}
            </button>
          )}
        </div>

        {!this.isLocked() && (
          <div className="pf-hint">
            รูปแรกคือรูปหน้าปกบนหน้าเว็บ · สูงสุด {MAX_IMAGES} รูป (เหลืออีก {Math.max(MAX_IMAGES - form.images.length, 0)} รูป) ·
            ไฟล์ละไม่เกิน {MAX_IMAGE_MB} MB · ระบบย่อให้เหลือ {IMAGE_RESIZE_PX}px อัตโนมัติ
          </div>
        )}

        {/* ★ เส้นบางคั่น แล้วต่อด้วยชุดสรุปแบบที่ผู้ซื้อจะเห็นบนหน้าประกาศ (อยู่การ์ดเดียวกับรูป) */}
        {showSummary && <div className="pf-divider" />}
        {showSummary && this.renderSummary()}
      </>,
      <span className="text-secondary text-12">{form.images.length} รูป</span>
    );
  };

  // ---------- ขวา : ข้อมูลทรัพย์ ----------

  renderPropertyCard = () => {
    const { form } = this.state;
    const isLand = form.property_type === "ที่ดิน";

    return this.card(
      "ข้อมูลทรัพย์",
      <>
        {this.chips(
          "selling_status",
          "สถานะทรัพย์",
          SELLING_STATUS.map((i) => ({ value: i, label: i }))
        )}

        <div className="row g-3">
          {/* ★ อาคาร / ชั้น / พื้นที่ใช้สอย มาจากทะเบียนลูกบ้าน (Customers)
              แก้ที่นี่ไม่ได้ ไม่งั้นข้อมูลห้องเดียวกันจะไม่ตรงกันสองที่ */}
          <div className="col-12 col-md-6">
            {this.input("building_no", "อาคาร", { disabled: true, hint: REGISTRY_HINT })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("floor", "ชั้น", { disabled: true, hint: REGISTRY_HINT })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("usable_area", "พื้นที่ใช้สอย (ตร.ม.)", {
              type: "number",
              required: true,
              disabled: true,
              hint: REGISTRY_HINT,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("land_area", "เนื้อที่ดิน (ตร.ว.)", {
              type: "number",
              placeholder: "เฉพาะบ้านและที่ดิน",
              hint: isLand ? "ที่ดินเปล่าใช้ช่องนี้เป็นหลัก" : "",
            })}
          </div>
          <div className="col-12 col-md-6">{this.input("bedroom_count", "จำนวนห้องนอน", { type: "number", decimalScale: 0, placeholder: "—" })}</div>
          {/* เพิ่มจากดีไซน์ — ผู้ซื้อถามสองอย่างนี้ต่อจากห้องนอนเสมอ */}
          <div className="col-12 col-md-6">{this.input("bathroom_count", "จำนวนห้องน้ำ", { type: "number", decimalScale: 0, placeholder: "—" })}</div>
          <div className="col-12 col-md-6">{this.input("parking_count", "ที่จอดรถ (คัน)", { type: "number", decimalScale: 0, placeholder: "—" })}</div>
        </div>

        <div className="pf-divider" />

        <div className="prop-label mb-2">ที่อยู่</div>
        <div className="row g-3">
          <div className="col-12 col-md-6">
            {/* ★ เลขที่ห้องมาจากทะเบียนห้อง (Customers) แก้ที่นี่ไม่ได้ ไม่งั้นข้อมูลสองที่จะไม่ตรงกัน */}
            {this.input("address_number", "บ้านเลขที่ / ห้องเลขที่", {
              required: true,
              disabled: true,
              hint: REGISTRY_HINT,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("building_name", "ชื่ออาคาร / โครงการ", { placeholder: "ระบุชื่อโครงการ" })}
          </div>
          <div className="col-12 col-md-6">{this.input("address_moo", "หมู่ที่", { placeholder: "—" })}</div>
          <div className="col-12 col-md-6">{this.input("address_soi", "ซอย", { placeholder: "—" })}</div>
          <div className="col-12 col-md-6">{this.input("address_road", "ถนน")}</div>
          {/* ★ เลือกเป็นลูกโซ่ จังหวัด > เขต/อำเภอ > แขวง/ตำบล แล้วเติมรหัสไปรษณีย์ให้อัตโนมัติ
              (ข้อมูลจาก assets/files/th_province.json) */}
          <div className="col-12 col-md-6">{this.provinceSelect()}</div>
          <div className="col-12 col-md-6">
            {this.addressSelect("address_district", "เขต / อำเภอ", this.districtList(), this.setDistrict, {
              required: true,
              placeholder: "เลือกเขต / อำเภอ",
              disabled: !this.state.form.address_province,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.addressSelect("address_subdistrict", "แขวง / ตำบล", this.subDistrictList(), this.setSubDistrict, {
              required: true,
              placeholder: "เลือกแขวง / ตำบล",
              disabled: !this.state.form.address_district,
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("address_postcode", "รหัสไปรษณีย์", {
              required: true,
              maxLength: 10,
              hint: "เติมให้อัตโนมัติจากตำบลที่เลือก แก้เองได้",
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.input("map_url", "ลิงก์แผนที่ (Google Maps)", { placeholder: "วางลิงก์หรือพิกัด" })}
          </div>
        </div>

        <div className="pf-divider" />

        <div className="pf-section mb-0">
          <label className="prop-label">สิ่งอำนวยความสะดวก</label>
          {/* ตารางไอคอน (ไอคอนบน ชื่อล่าง) อ่านเร็วกว่าชิปแถวยาว ๆ เพราะกวาดตาเป็นคอลัมน์ได้ */}
          <div className="pf-typegrid">
            {FACILITY_OPTIONS.map((item) => (
              <button
                key={item.label}
                type="button"
                aria-pressed={form.facilities.includes(item.label)}
                className={`pf-type ${form.facilities.includes(item.label) ? "is-active" : ""}`}
                disabled={this.isLocked()}
                onClick={() => this.toggleFacility(item.label)}
              >
                <span className="icon">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </>
    );
  };

  // ข้อมูลที่ระบบเดิมมีอยู่แล้วแต่ไม่มีในดีไซน์ — ยกมาไว้ท้ายคอลัมน์ขวา
  renderWebContentCard = () =>
    this.card(
      "ข้อมูลบนหน้าเว็บ",
      <>
        {this.input("highlight", "จุดเด่น (1 บรรทัด แสดงบนการ์ด)", {
          maxLength: 200,
          placeholder: "เช่น ห้องมุม วิวสวน ตกแต่งครบพร้อมเข้าอยู่",
        })}
        {this.textarea("description", "รายละเอียดห้อง", { rows: 5, placeholder: "ระบุข้อมูลเพิ่มเติมของห้อง" })}
      </>
    );

  // ---------- ขั้นตอน (ฝั่งลูกบ้าน) ----------

  goStep = (next) => {
    if (next < 1 || next > STEPS.length) return;
    this.setState({ step: next }, () => window.scrollTo({ top: 0, behavior: "smooth" }));
  };

  renderStep = () => {
    const { form, step } = this.state;
    const showSale = hasSale(form.listing_type);
    const showRent = hasRent(form.listing_type) || form.sell_with_tenant;

    if (step === 1) {
      return (
        <div className="row g-3">
          <div className="col-xl-6">
            <div className="d-flex flex-column gap-3">
              {this.renderListingType()}
              {this.renderAnnounceCard()}
            </div>
          </div>
          <div className="col-xl-6">
            <div className="d-flex flex-column gap-3">
              {showSale && this.renderSaleCard()}
              {showRent && this.renderRentCard()}
              {showRent && this.renderTenantCard()}
            </div>
          </div>
        </div>
      );
    }

    // ขั้นรูปภาพมีงานเดียว — จัดการ์ดไว้กลางหน้า ไม่ต้องกินความกว้างเต็มจอจนรูปลอยอยู่คนละมุมกับปุ่ม
    if (step === 2) {
      return (
        <div className="row g-3 justify-content-center">
          <div className="col-12 col-xl-9">{this.renderMediaCard({ showSummary: false })}</div>
        </div>
      );
    }
    if (step === 3) return this.renderPropertyCard();

    // ขั้นสุดท้าย — ชุดสรุปแบบที่ผู้ซื้อจะเห็น + ข้อมูลบนหน้าเว็บ + หมายเหตุถึงผู้ดูแล ก่อนกดส่ง
    // ★ ข้อมูลติดต่อ Admin เป็นของฝั่งผู้ดูแล ลูกบ้านไม่ต้องกรอก (ค่าเดิมยังถูกส่งกลับตามเดิมตอนบันทึก)
    return (
      <div className="row g-3">
        <div className="col-xl-7">{this.renderMediaCard()}</div>
        <div className="col-xl-5">
          <div className="d-flex flex-column gap-3">
            {this.renderWebContentCard()}
            {this.renderOwnerNoteCard()}
          </div>
        </div>
      </div>
    );
  };

  renderStepBar = () => {
    const { step } = this.state;
    return (
      <div className="prop-card prop-in mb-3">
        <div className="pf-steps" style={{ gridTemplateColumns: `repeat(${STEPS.length}, 1fr)` }} data-testid="step-bar">
          {STEPS.map((item) => (
            <button
              key={item.no}
              type="button"
              title={item.label}
              className={`pf-step ${item.no < step ? "is-done" : ""} ${item.no === step ? "is-active" : ""}`}
              onClick={() => this.goStep(item.no)}
            >
              <span className="pf-step__dot">
                {item.no < step ? <span className="icon text-12">{"\uf00c"}</span> : item.no}
              </span>
              <span className="pf-step__label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { room, form, saving, publishing, loaded, errorMessage, step } = this.state;
    const project = this.project;
    const busy = saving || publishing;
    const isCreate = !form.listing_uid;
    const showSale = hasSale(form.listing_type);
    const showRent = hasRent(form.listing_type) || form.sell_with_tenant;
    const badge = PUBLISH_BADGE[form.publish_status] || null;
    // อนุมัติ/ไม่อนุมัติเป็นงานของผู้ดูแล และทำได้เฉพาะประกาศที่บันทึกแล้ว
    const canApprove = !this.isCustomer && !isCreate;
    // ลูกบ้าน : ส่งเผยแพร่ / ยกเลิกการเผยแพร่ ได้เอง (ประกาศที่เผยแพร่แล้วถูกล็อกไปก่อนหน้านี้)
    // ★ รวมกรณีลงประกาศใหม่ (isCreate) ด้วย — ไม่งั้นขั้นตอนสุดท้ายของประกาศใหม่จะไม่มีปุ่มส่งข้อมูลเลย
    const canRequest = this.isCustomer && !this.isLocked();

    if (loaded && errorMessage) {
      return (
        <div className="w-100 min-vh-100 prop-page">
          <PropertyNavbar menuKey="sales-room-all" page1="จัดการทรัพย์" page2="แก้ไขทรัพย์" projectName={project?.project_name} />
          <div className="body p-4">
            <div className="prop-card prop-in">
              <div className="prop-empty">
                <div className="prop-empty__icon icon">{"\uf05a"}</div>
                <div className="fw-bold text-dark mb-1">เปิดหน้านี้ไม่ได้</div>
                <div className="text-12">{errorMessage}</div>
                <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.cancel}>
                  กลับไปหน้าจัดการทรัพย์
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="w-100 min-vh-100 prop-page">
        <PropertyNavbar
          menuKey="sales-room-all"
          page1="จัดการทรัพย์"
          page2={isCreate ? "ลงประกาศทรัพย์" : "รายละเอียดทรัพย์"}
          projectName={project?.project_name}
        />

        <div className="body p-4">
          {/* หัวข้อหน้า — มุมขวาบนเหลือแค่ป้ายสถานะการเผยแพร่ (ปุ่มอนุมัติ/ไม่อนุมัติอยู่แถบล่าง) */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div className="d-flex align-items-center gap-3">
              {!this.isCustomer && (
                <button type="button" className="prop-iconbtn icon" title="ย้อนกลับ" onClick={this.cancel}>
                  {"\uf053"}
                </button>
              )}
              <div>
                <h3 className="fw-bold mb-1 text-dark">
                  {isCreate ? "ลงประกาศทรัพย์" : "รายละเอียดทรัพย์"} ห้อง {room?.address_number || ""}
                </h3>
                <div className="text-secondary text-14">
                  {room?.full_name ? `เจ้าของ ${room.full_name}` : "ยังไม่ระบุเจ้าของห้อง"}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap">
              {!!badge && (
                <span
                  className="prop-tag"
                  data-testid="publish-badge"
                  style={{ background: badge.tint, borderColor: badge.tint, color: badge.color }}
                >
                  {badge.label}
                </span>
              )}
            </div>
          </div>

          {/* ★ ผู้ใช้ที่ไม่มีสิทธิ์เขียน — บอกตรง ๆ ว่าทำไมช่องกรอกกดไม่ได้และไม่มีปุ่มบันทึก */}
          {loaded && !this.isCustomerLocked() && !this.canWrite() && (
            <div className="prop-card prop-in mb-3" data-testid="no-permission-banner">
              <div className="p-3 d-flex align-items-center gap-2 text-14 text-secondary">
                <span className="icon text-14">{"\uf023"}</span>
                {isCreate
                  ? "บัญชีนี้ไม่มีสิทธิ์ลงประกาศ (ดูได้อย่างเดียว)"
                  : "บัญชีนี้ไม่มีสิทธิ์แก้ไขประกาศ (ดูได้อย่างเดียว)"}
              </div>
            </div>
          )}

          {this.isCustomerLocked() && (
            <div className="prop-card prop-in mb-3" data-testid="locked-banner">
              <div
                className="p-3 d-flex align-items-center gap-2 text-14"
                style={{ color: form.publish_status === PUBLISH_STATUS.PENDING ? "#8a5a00" : "#166534" }}
              >
                <span className="icon text-14">{"\uf05a"}</span>
                {form.publish_status === PUBLISH_STATUS.PENDING
                  ? "ส่งข้อมูลให้ผู้ดูแลตรวจแล้ว จึงแก้ไขไม่ได้ระหว่างรอผลตรวจ · ต้องการแก้ไขกรุณาติดต่อผู้ดูแลโครงการ"
                  : "ประกาศนี้เผยแพร่บนหน้าเว็บแล้ว จึงแก้ไขข้อมูลไม่ได้ · ต้องการแก้ไขกรุณาติดต่อผู้ดูแลโครงการ"}
              </div>
            </div>
          )}

          {loaded && this.isCustomer && this.renderStepBar()}

          {loaded && this.isCustomer && this.renderStep()}

          {loaded && !this.isCustomer && (
            <div className="row g-3">
              {/* ---------- คอลัมน์ซ้าย : ข้อมูลของประกาศ ---------- */}
              <div className="col-xl-5">
                <div className="d-flex flex-column gap-3">
                  {/* ข้อมูลที่มาจากเจ้าของห้อง อยู่บนสุด — ผู้ดูแลต้องเห็นก่อนลงไปตรวจตัวเลข */}
                  {this.renderOwnerNoteCard()}
                  {this.renderListingType()}
                  {showSale && this.renderSaleCard()}
                  {showRent && this.renderRentCard()}
                  {showRent && this.renderTenantCard()}
                  {this.renderAnnounceCard()}
                  {this.renderContactCard()}
                </div>
              </div>

              {/* ---------- คอลัมน์ขวา : รูป + ชุดสรุป + ข้อมูลทรัพย์ ---------- */}
              <div className="col-xl-7">
                <div className="d-flex flex-column gap-3">
                  {this.renderMediaCard()}
                  {this.renderPropertyCard()}
                  {this.renderWebContentCard()}
                </div>
              </div>
            </div>
          )}

          {!loaded && <div className="prop-card prop-in p-5 text-center text-secondary">กำลังโหลดข้อมูล...</div>}

          {/* แถบปุ่มด้านล่าง */}
          <div className="pf-footer">
            {this.isCustomer ? (
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="prop-btn prop-btn--ghost"
                  disabled={step === 1}
                  onClick={() => this.goStep(step - 1)}
                >
                  <span className="icon text-12">{"\uf053"}</span>
                  ย้อนกลับ
                </button>
                <span className="text-secondary text-12 d-none d-md-inline">
                  ขั้นที่ {step} / {STEPS.length} · {STEPS[step - 1].label}
                </span>
              </div>
            ) : (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.cancel}>
                <span className="icon text-12">{"\uf053"}</span>
                กลับไปหน้ารายการ
              </button>
            )}

            {/* ลูกบ้านยังไม่ถึงขั้นสุดท้าย = มีแค่ปุ่ม "ถัดไป" (ปุ่มบันทึก/ส่งเผยแพร่อยู่ขั้นสุดท้าย) */}
            {/* ★ ประกาศที่ล็อกแล้วยังเดินดูทุกขั้นได้ (ปุ่มถัดไปยังอยู่) แต่ไม่มีปุ่มบันทึก */}
            {this.isCustomer && step < STEPS.length && (
              <div className="d-flex align-items-center gap-2">
                {/* บันทึกค้างไว้ระหว่างกรอก — ไม่เช็คความครบ และไม่เปลี่ยนสถานะเผยแพร่ */}
                {!this.isLocked() && (
                  <button type="button" className="prop-btn prop-btn--ghost" disabled={busy} onClick={() => this.save({ draft: true })}>
                    <span className="icon text-12">{"\uf0c7"}</span>
                    {saving ? "กำลังบันทึก..." : "บันทึกร่าง"}
                  </button>
                )}
                <button type="button" className="prop-btn" onClick={() => this.goStep(step + 1)}>
                  ถัดไป
                  <span className="icon text-12">{"\uf054"}</span>
                </button>
              </div>
            )}

            {!this.isLocked() && (!this.isCustomer || step === STEPS.length) && (
              <div className="d-flex align-items-center gap-2">
                {/* ★ ปุ่มปฏิเสธ/อนุมัติประกาศ ไม่ใช่ปุ่มยกเลิก-บันทึกการแก้ไข
                    ปฏิเสธเป็นสีแดงกันกดสลับกัน และเปิดให้กดได้ทุกสถานะ
                    (ประกาศที่เผยแพร่แล้วต้องปิดกลับได้ ประกาศที่ปิดอยู่ต้องเปิดใหม่ได้) */}
                {/* ประกาศที่ปิดเผยแพร่อยู่แล้ว ไม่ต้องมีปุ่มปฏิเสธซ้ำ — เหลือทางเดียวคืออนุมัติให้ขึ้นเว็บ */}
                {/* ★ disable ทุกปุ่มระหว่างรอ API (บันทึก/อนุมัติ) — กดซ้ำเดิมยิงซ้อนกัน */}
                {canApprove && form.publish_status !== PUBLISH_STATUS.HIDDEN && (
                  <button type="button" className="prop-btn prop-btn--danger" disabled={busy} onClick={() => this.setPublish(false)}>
                    ไม่อนุมัติ
                  </button>
                )}
                {canApprove && (
                  <button type="button" className="prop-btn prop-btn--primary" disabled={busy} onClick={() => this.setPublish(true)}>
                    <span className="icon text-12">{"\uf00c"}</span> อนุมัติ (เผยแพร่)
                  </button>
                )}

                {/* ★ ลูกบ้านมี 2 ปุ่ม : บันทึกร่าง (เก็บไว้ก่อน ไม่เปลี่ยนสถานะ) กับ ส่งข้อมูล (บันทึก + เข้าคิวรออนุมัติ)
                    ส่งแล้วถอนเองไม่ได้ ต้องให้ผู้ดูแลเป็นคนตัดสิน */}
                {canRequest && (
                  <button type="button" className="prop-btn prop-btn--ghost" disabled={busy} onClick={() => this.save({ draft: true })}>
                    <span className="icon text-12">{"\uf0c7"}</span>
                    {saving ? "กำลังบันทึก..." : "บันทึกร่าง"}
                  </button>
                )}
                {canRequest && (
                  <button type="button" className="prop-btn prop-btn--primary" disabled={busy} onClick={this.submitForReview}>
                    <span className="icon text-12">{"\uf1d8"}</span> ส่งข้อมูล
                  </button>
                )}
                {/* ★ ลงประกาศใหม่ : แยก "บันทึก" (เก็บข้อมูลอย่างเดียว ไม่ขึ้น Salepage) ออกจาก "อนุมัติ (เผยแพร่)" (ขึ้น Salepage ทันที) */}
                {!this.isCustomer && isCreate && (
                  <button
                    type="button"
                    className="prop-btn prop-btn--ghost"
                    disabled={busy}
                    onClick={() => this.save({ publish: false })}
                  >
                    <span className="icon text-12">{"\uf0c7"}</span>
                    {saving ? "กำลังบันทึก..." : "บันทึก"}
                  </button>
                )}
                {!this.isCustomer && isCreate && (
                  <button
                    type="button"
                    className="prop-btn prop-btn--primary"
                    disabled={busy}
                    onClick={() => this.save({ publish: true })}
                  >
                    <span className="icon text-12">{"\uf00c"}</span> {saving ? "กำลังบันทึก..." : "อนุมัติ (เผยแพร่)"}
                  </button>
                )}
                {!this.isCustomer && !isCreate && (
                  <button type="button" className="prop-btn" disabled={busy} onClick={() => this.save()}>
                    <span className="icon text-14">{"\uf0c7"}</span>
                    {saving ? "กำลังบันทึก..." : "บันทึกการแก้ไข"}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
